export const BASIC_ACTION_TYPE = {
  LIST_LOADING: 'LIST_LOADING',
  LIST_LOADED: 'LIST_LOADED',
  LIST_ERROR: 'LIST_ERROR'
};

export function createActionTypes (actionTypes) {
  let actionTypesMap = {};
  actionTypes.forEach((actionType) => {
    actionTypesMap[actionType] = actionType;
  });
  return actionTypesMap;
}

export function nameSpacedActionType (nameSpace, actionType) {
  let newActionType = {};
  Object.keys(actionType).forEach((key) => {
    newActionType[key] = `${nameSpace}/${actionType[key]}`;
  });
  return newActionType;
}

export function getNestedActionCreators (actionCreator, typePrefix) {
  return (...args) => {
    actionCreator(...args, (type) => `${typePrefix}${type}`);
  };
}



/** WEBPACK FOOTER **
 ** ./src/redux/utils/actionUtils.js
 **/